var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name != 'company-home')?_c('b-breadcrumb',{staticClass:"p-0 mt-3 bg-transparent",attrs:{"items":_vm.breadcrumbs}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }